import * as React from 'react';

export enum EKeycodes {
  ArrowDown = 40,
  ArrowUp = 38,
  Escape = 27,
}

export const onKeyPressedCreator =
  (keyCode: EKeycodes) =>
  (fn?: Function) =>
  <T>(e: React.KeyboardEvent<T>) => {
    if (e.keyCode === keyCode && typeof fn === 'function') {
      fn();
    }
  };
export const onEscPressed = onKeyPressedCreator(EKeycodes.Escape);
